export const buildBannerType = (formData: any): string => {
  const { league } = formData;

  if (!league) {
    return 'espn/espn-vs/futbol';
  }

  return `espn/espn-vs/futbol/${league}/miniatura`;
};
